import { gql } from 'graphql-tag';

export default gql`
  query GetMarketingAsset($id: ID!, $language: String, $country: String) {
    getMarketingAsset(id: $id, language: $language, country: $country) {
      category
      destinationUrl
      altText
      cdnUrl
    }
  }
`;
